import p from './spent-of-device.vue';

export default p;
